import { Preferences } from "../../profile/objects/preferences";
import { Column } from "../objects/column";
import { FUNNEL_BOOKING_AUTHORIZATION_MODULE, BOOKING_AUTHORIZATION_DEFAULT_COLUMNS } from "../constant/funnelBookingAuthorizationConstant";
import { setListPreference, ListPreferenceResult } from "../../utils/list/utils/setListPreference";

export const setFunnelBookingAuthorizationPreference = (new_preferences: Preferences[], state_columns: Column[]): ListPreferenceResult =>
    setListPreference(new_preferences, state_columns, {
        module: FUNNEL_BOOKING_AUTHORIZATION_MODULE,
        default_columns: BOOKING_AUTHORIZATION_DEFAULT_COLUMNS,
        default_order_by: '',
    });
